import type { FunctionComponent } from "react";
import styled, { css } from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ChangeValue } from "@similarweb/ui-components";
import { yAxisChangeFilter } from "app/filters/ngFilters";

const TooltipContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    ${setFontVariant("body2")};
`;

const TooltipMarkerName = styled.span<{ marginRight?: number }>`
    ${({ marginRight }) =>
        marginRight &&
        css`
            margin-right: ${marginRight}px;
        `};
    color: ${colorsPalettes.carbon[500]};
`;

const TooltipMarker = styled.span<{ backgroundColor: string }>`
    flex-shrink: 0;
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: 100%;
    height: 12px;
    width: 12px;
    margin-right: 14px;
`;
const ChangeValueCell = styled(ChangeValue)`
    margin-left: 8px;
`;
interface IPieChartTooltipProps {
    color: string;
    name: string;
    value: any;
    change?: number;
}

const PieChartTooltip: FunctionComponent<IPieChartTooltipProps> = (props) => (
    <TooltipContainer>
        <TooltipMarker backgroundColor={props.color} />
        <TooltipMarkerName marginRight={48}>{props.name}</TooltipMarkerName>
        <TooltipMarkerName>{props.value}</TooltipMarkerName>
        {props.change ? <ChangeValueCell
                descriptionText={""}
                isDecrease={props.change < 0}
                value={yAxisChangeFilter()(props.change, 0)}
            /> : null}
    </TooltipContainer>
);

export default PieChartTooltip;
